/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { a as __rest } from '../../../tslib.es6-e01eabb2.js';
import { a as getRealWebUrl } from '../../../common-42e7d8d8.js';
import { loadPanguMiniAppDependLibs, JSCall } from '../../../bridges/pangu-mini-app/index.js';
import '../../../safe-data-66f20265.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';

function navigateTo(params) {
    var success = params.success, fail = params.fail, rest = __rest(params, ["success", "fail"]);
    // 该API特殊处理。因为传递是string字符串，不符合uni-api底层传递Object规范。
    loadPanguMiniAppDependLibs().then(function () {
        var targetUrl = getRealWebUrl(rest);
        JSCall('openUrl', targetUrl, success, fail);
    });
}

export { navigateTo as default };
